module.exports = __webpack_public_path__ + "img/IMG_1838.d10b8e0c.jpg";